import amplitude from 'amplitude-js/amplitude';
import {ACTIVE_PROFILE, RELEASE_TAG} from "../../config";

const AMPLITUDE_KEY = ACTIVE_PROFILE === "prod" ? "89ee3019f8ac54c4072f63de040d30ca" : "fd7ef418d90831244c2ee5fa202f357f";

export const initAmplitude = () => {
  amplitude.getInstance().init(AMPLITUDE_KEY, null, {
    // logLevel: 'INFO',
    platform: 'Web - Preview'
  });
  amplitude.getInstance().setVersionName(RELEASE_TAG);
};

export const logSocialShareViewEvent = (name) => {
  amplitude.getInstance().logEvent("Social Share View",  {"Experience Name": name});
};

export const logDownloadAppClickEvent = (from, platform, url) => {
  amplitude.getInstance().logEvent("Download App Click",  {"Retailer": "Dabbl", "From": from, "To": platform, "Url": url});
};

export const logSocialLinkClickEvent = (name) => {
  amplitude.getInstance().logEvent("Social Link Click",  {"Experience Name": name});
};

export const logCtaClickEvent = (name, id, brandName, url) => {
  amplitude.getInstance().logEvent("Conclusion Link Click",  {"Campaign Name": name, "Campaign Id": id, "Brand Name": brandName, "Actual URL": url});
};

export const getAmplitudeDeviceId = () => {
  return amplitude.getInstance().options.deviceId;
};



// WEBPACK FOOTER //
// ./src/shared/redux/amplitude.js